import { Row, Col, Form, Button, Typography, Image } from "antd";
import OTPInput from "otp-input-react";
import Logo from "../../assets/Spectus_new_logo_high_resolution.png";
import LoginStyle from "../login/LoginStyle";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { FastBackwardFilled } from "@ant-design/icons";
import axios from "axios";
import "../login/index.css";

const { default: env } = require("../../config/env.js");

const EmailVerification = () => {
  const validUsers = [];
  const validUserEmail = [];
  const location = useLocation();
  const Navigate = useNavigate();
  const [OTP, setOTP] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [sendOTP, setSendOTP] = useState();
  const [preventDoubleClick, setpreventDoubleClick] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(59);

  const handleChange = (e) => {
    setErrorMessage("");
    setOTP(e);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    setSendOTP(location.state.code);
  }, []);

  const onFinish = () => {
    if (OTP == sendOTP) {
      Navigate("/reset-password", {
        state: {
          email_address: location.state.email_address,
          logindetails: location.state.loginUser,
        },
      });
    } else {
      setErrorMessage("Please input valid verification code!");
    }
  };

  const handleResend = async () => {
    setMinutes(0);
    setSeconds(59);
    const email = location.state.email_address;

    setpreventDoubleClick(true);

    // const verification_code = Math.floor(Math.random() * 1000000);
    const verification_code = Math.floor(100000 + Math.random() * 900000);
    setSendOTP(verification_code);

    var date = new Date();
    var time = date.toLocaleString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    var d = date.toLocaleDateString([], {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    var templateParams = {
      to_name: location.state.name,
      to_email: location.state.email_address,
      to_date: `${d}, ${time}`,
      verification_code: verification_code,
      subject: `Reset Password Verification Code ${env.subject_mode}`,
      type: "forgot_password",
      from_email: env.basic_email_params.from_email,
    };

    await axios.post(`${env.backend_api_endpoint}/send-email`, {
      ...templateParams,
    });
  };

  return (
    <LoginStyle>
      <div className="mainLoginDiv">
        <div className="img_div">
          <Image src={Logo} preview={false}></Image>
        </div>

        <div className="form_card">
          <h3
            style={{
              fontSize: "36px",
              fontWeight: "600",
              color: "#244DA0",
              fontStyle: "normal",
              textAlign: "left",
              padding: "22px",
              fontFamily: "ImportedMilliardBold",
            }}
          >
            Email Verification
          </h3>
          <div className="form_item">
            <Form
              name="basic"
              // labelCol={{
              //   xs: { span: 24 },
              //   sm: { span: 12 },
              //   md: { span: 8 },
              //   lg: { span: 8 },
              // }}
              // wrapperCol={{
              //   xs: { span: 24 },
              //   sm: { span: 12 },
              //   md: { span: 12 },
              //   lg: { span: 12 },
              // }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item
                name="verification_code"
                label="Please enter the verification code sent to your registered email adderess"
                style={{
                  fontWeight: "500",
                  fontSize: "20px",
                  fontFamily: "Milliard",
                }}
                rules={[
                  {
                    required: true,
                    message:
                      "Please enter OTP which is sent to your registered email address!",
                    validateTrigger: ["onSubmit"],
                  },
                ]}
                // labelCol={{ offset: 4, span: 16 }}
                // wrapperCol={{ offset: 4, span: 16 }}
                className="fileds"
              >
                <OTPInput
                  className="OTP_text"
                  onChange={handleChange}
                  autoFocus
                  OTPLength={6}
                  otpType="number"
                  secure
                  disable={false}
                />
              </Form.Item>
              {errorMessage === "" ? (
                ""
              ) : (
                <p
                  style={{
                    color: "red",
                    marginTop: "-25px",
                    marginLeft: "75px",
                  }}
                >
                  {errorMessage}
                </p>
              )}
              <Form.Item
              // wrapperCol={{ offset: 4, span: 16 }}
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#244DA0",
                    borderRadius: "6px",
                    marginTop: "100px",
                    marginBottom: "20px",
                    fontWeight: "500",
                    fontSize: "18px",
                    padding: "2px",
                    height: "46px",
                  }}
                >
                  Reset Password
                </Button>
              </Form.Item>
            </Form>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: "10px",
              }}
            >
              {seconds > 0 || minutes > 0 ? (
                <p>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p>Didn't recieve code? &nbsp;</p>
              )}
              <Button
                disabled={seconds > 0 || minutes > 0}
                style={{
                  color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#244DA0",
                  marginLeft: "5px",
                  padding: "0px",
                  border: "none",
                  backgroundColor: "white",
                }}
                onClick={handleResend}
              >
                Resend OTP
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* <Col span={10} offset={2}> */}
      {/* <div className="border-2 border-gray-200 bg-white p-5 border-r-4 Container"> */}
      {/* <Typography
              style={{
                fontSize: "36px",
                fontWeight: "600",
                color: "#244DA0",
                fontStyle: "normal",
                textAlign: "left",
                marginLeft: "50px",
                padding: "22px",
              }}
            >
              Email Verification
            </Typography> */}
      {/* <Form
              name="basic"
              labelCol={{
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 8 },
                lg: { span: 8 },
              }}
              wrapperCol={{
                xs: { span: 24 },
                sm: { span: 12 },
                md: { span: 12 },
                lg: { span: 12 },
              }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
              layout="vertical"
            >
              <Form.Item
                name="verification_code"
                label="Please enter the verification code sent to your registered email adderess"
                style={{
                  fontWeight: "500",
                  fontSize: "20px",
                  fontFamily: "Milliard",
                }}
                rules={[
                  {
                    required: true,
                    message:
                      "Please enter OTP which is sent to your registered email address!",
                    validateTrigger: ["onSubmit"]
                  },

                ]}
                labelCol={{ offset: 4, span: 16 }}
                wrapperCol={{ offset: 4, span: 16 }}
                className="fileds"
              >
                <OTPInput
                  onChange={handleChange}
                  autoFocus
                  OTPLength={6}
                  otpType="number"
                  secure
                  disable={false}
                />

              </Form.Item>
              {errorMessage === "" ? (
                ""
              ) : (
                <p style={{ color: "red", marginTop: "-25px", marginLeft: "75px" }}>{errorMessage}</p>
              )}
              <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  style={{
                    background: "#244DA0",
                    borderRadius: "6px",
                    marginTop: "158px",
                    marginBottom: "20px",
                    fontWeight: "500",
                    fontSize: "18px",
                    padding: "2px",
                    height: "46px",
                  }}
                >
                  Reset Password
                </Button>
              </Form.Item>
            </Form>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {seconds > 0 || minutes > 0 ? (
                <p>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                  {seconds < 10 ? `0${seconds}` : seconds}
                </p>
              ) : (
                <p>Didn't recieve code? &nbsp;</p>
              )}
              <Button
                disabled={seconds > 0 || minutes > 0}
                style={{
                  color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#244DA0",
                  marginLeft: '10px',
                  marginBottom: '10px',
                  padding: '0px',
                  border: 'none',
                  backgroundColor: 'white'
                }}
                onClick={handleResend}
              >
                Resend OTP
              </Button>
            </div>
          </div>
        </Col> */}
      {/* </Row> */}
    </LoginStyle>
  );
};

export default EmailVerification;
